<template>
  <div class="data-list-container">
    <vs-card >
      <div slot="header">
        <h3>Lead Status Management</h3>
      </div>
      <div slot="media" class="p-3">
        <vs-button
          icon-pack="feather"
          icon="icon-plus"
          style="float: right; margin-right: 1%;"
          @click="handleAddStatus"
        >
          New Status
        </vs-button>
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <vs-list class="list-holder cstm_list-holder">
              <vs-list-header title="All Status"/>
              <draggable :list="allStatus" group="status" class="p-2 cursor-move status_card_holder" style="min-height:30vh;">
                <transition-group>
                  <vx-card class="list-item" v-for="(status_list, index) in allStatus" :key="index" :title="status_list.status_name">
                    <vs-row vs-type="flex" vs-justify="flex-end">

                      <vs-button radius @click="handleStatusEdit(status_list)" icon-pack="feather" icon="icon-edit" color="primary" class="mr-2" v-if="status_list.status_name !== 'New' "/>
                      <vs-button radius @click="handleStatusDelete(status_list)" icon-pack="feather" icon="icon-trash" color="danger" v-if="status_list.status_name !== 'New' "/>
                    </vs-row>
                    <!-- <vs-chip color="danger" closable @click="handleRemoveStatusList(status_list.status_id)" style="float:left;"> {{ status_list.status_name }} </vs-chip> -->
                  </vx-card>
                </transition-group>
              </draggable>
            </vs-list>
          </vs-col>
          <vs-col vs-w="6">
            <vs-list class="list-holder">
              <vs-list-header title="Active Status"/>
              <draggable :list="activeStatus" group="status" class="p-2 cursor-move status_card_holder" style="min-height:30vh;">
                <transition-group>
                  <vs-list-item vs-type="flex" vs-justify="flex-start" class="list-item active-list" v-for="(active_status_list, index) in activeStatus" :key="index" :title="active_status_list.status_name">
                    <template slot="avatar">
                      <vs-row vs-type="flex" vs-justify="center" vs-align="center" class="bg-primary" style="height:30px;width:30px;border-radius:50%;margin-right:10px;"><h4 style="color:white;">{{index + 1}}</h4></vs-row>
                    </template>
                  </vs-list-item>
                </transition-group>
              </draggable>
            </vs-list>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
    <vs-popup  title="Add new status" :active.sync="addstatusModal">
      <vs-row>
        <form data-vv-scope="add_status" class="w-full">
          <span>Status Name</span>
          <vs-input v-validate="'required'" v-model="newstatus_name" name="Status Name" class="mt-3 w-full" />
          <span class="text-danger text-sm" v-show="errors.has('add_status.Status Name')">{{ errors.first('add_status.Status Name') }}</span>
        </form>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button id="save_status_id" @click="handleSaveStatus" color="primary" type="filled" class="mr-2 vs-con-loading__container">Save</vs-button>
        <vs-button @click="handlecreateStatus" color="primary" type="border">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <!-- edit popup -->
    <vs-popup  title="Edit status" :active.sync="editmodalpopupfalg">
      <vs-row>
        <form data-vv-scope="edit_status" class="w-full">
          <span>Status Name</span>
          <vs-input v-validate="'required'" name="Status Name" v-model="edited_status.status_name_modal" class="mt-3 w-full" />
          <span class="text-danger text-sm" v-show="errors.has('edit_status.Status Name')">{{ errors.first('edit_status.Status Name') }}</span>
        </form>

      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button id="edit_status_id" @click="handleSaveEditedStatus" color="primary" type="filled" class="mr-2 vs-con-loading__container">Update</vs-button>
        <vs-button @click="editmodalpopupfalg=false" color="primary" type="border">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <!-- delete popup -->
    <vs-popup  title="Please Confirm" :active.sync="deletemodalpopupfalg">
      <vs-row>
        <span>Are you sure to delete this status?</span>
        <!-- <vs-input placeholder="Status Name"  vs-placeholder="Status Name" v-model="newstatus_name" class="mt-3 w-full" /> -->
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button id="delete_status_id" @click="handleDeleteCOnfirmation" color="danger" type="filled" class="mr-2 vs-con-loading__container">Accept</vs-button>
        <vs-button @click="deletemodalpopupfalg=false" color="danger" type="border">Cancel</vs-button>
      </vs-row>
    </vs-popup>
    <!-- <vs-prompt
      title= "Add new status"
      @cancel="addstatusModal = false"
      @add="acceptAlert"
      @close="close"
      :active.sync="addstatusModal">
      <div class="con-exemple-prompt">
        <span>Status Name</span>
      <vs-input placeholder="Status Name" vs-placeholder="Status Name" v-model="newstatus_name" class="mt-3 w-full" />
      </div>
    </vs-prompt> -->
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { active_lead_status, all_leads_status, arrange_leads_status, create_lead_status, edit_status, delete_status } from '@/api/leads'
// import vsDialog from 'vsDialog'
export default {
  name: 'statusManagement',
  components: {
    draggable
    // vsDialog
  },
  data () {
    return {
      allstat:[],
      allStatus: [],
      activeStatus:[],
      addstatusModal: false,
      newstatus_name: '',
      editmodalpopupfalg: false,
      deletemodalpopupfalg: false,
      edited_status: {
        status_name_modal: null,
        full_status: {}
      },
      deleted_status: {}

    }
  },
  mounted () {
    this.fetch_leads_active_status()
    all_leads_status(this.$store.getters.customerId)
      .then(data => {
        this.allstat = data.data.data.leads_status_list
        active_lead_status(this.$store.getters.customerId)
          .then((data) => {
            const newArray = []
            this.activeStatus = data.data.data.leads_status_list
            this.allStatus = this.allstat.filter(ele => {
              this.activeStatus.forEach(item => {
                if (ele.leads_status_id === item.leads_status_id) {
                  newArray.push(item.leads_status_id)
                }
              })
              //return ele 
              if (newArray.includes(ele.leads_status_id) === false) {
                return ele
              }
            })
          })
        this.$vs.close()
      }).catch(e => {
        
      })
    
  },
  methods: {
    handleRemoveActiveStatus (status_id) {
      const active_status_list = this.activeStatus
      for (let i = 0; i < active_status_list.length; i++) {
        if (active_status_list[i].status_id === status_id) {
          this.activeStatus.splice(i, 1)
        }
      }
      // this.activeStatus = active_status_list
    },
    handleAddStatus () {
      this.addstatusModal = true
    },
    fetch_leads_active_status () {
      active_lead_status(this.$store.getters.customerId).then(data => {
        this.activeStatus = data.data.data.leads_status_list
      }).catch(e => {
        
      })
    },
    async handleSaveStatus () {
      this.$validator.validateAll('add_status').then(valid => {
        if (valid) {
          this.$vs.loading({
            container: '#save_status_id'
          })
          const payload = {
            status_name: this.newstatus_name,
            status_display_label : this.newstatus_name,
            customer_id : this.$store.getters.customerId
          }
          create_lead_status(payload)
            .then(data => {
              this.allStatus.push(data.data.data.leads_status)
              this.addstatusModal = false
              this.newstatus_name = ''
              this.$vs.loading.close('#save_status_id > .con-vs-loading')
              this.$vs.notify({
                title: 'Success',
                text: 'Status added Successfully',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
            }).catch(e => {
              this.$vs.loading.close('#save_status_id > .con-vs-loading')
              this.$vs.notify({
                title: 'Error',
                text: 'Status name already exists',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              
            })
        }
      })

    },
    handleStatusEdit (status_details) {
      this.edited_status.full_status  =  status_details
      this.edited_status.status_name_modal =  status_details.status_name
      this.editmodalpopupfalg = true
    },
    async handleSaveEditedStatus () {
      this.$validator.validateAll('edit_status').then(valid => {
        if (valid) {
          this.$vs.loading({
            container: '#edit_status_id'
          })
          const payload = {
            status_name : this.edited_status.status_name_modal,
            leads_status_id : this.edited_status.full_status.leads_status_id
          }
          edit_status(payload)
            .then(data => {
              const index = this.allStatus.findIndex(element => element.leads_status_id === payload.leads_status_id)
              this.allStatus[index] = data.data.data.leads_status
              this.editmodalpopupfalg = false
              this.$vs.notify({
                title: 'Success',
                text: 'Status updated Successfully',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              this.$vs.loading.close('#edit_status_id > .con-vs-loading')
            })
            .catch(e => {
              this.$vs.loading.close('#edit_status_id > .con-vs-loading')
              this.$vs.notify({
                title: 'Error',
                text: e,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              
            })
        }
      })
    },
    handleStatusDelete (status_details) {
      this.deleted_status = status_details
      this.deletemodalpopupfalg = true
    },
    async handleDeleteCOnfirmation () {
      try {
        this.$vs.loading({
          container: '#delete_status_id'
        })
        const leads_status_id =  this.deleted_status.leads_status_id
        await delete_status(leads_status_id)
        
        const index = this.allStatus.findIndex(element => element.leads_status_id === leads_status_id)
        this.allStatus.splice(index, 1)
        this.deletemodalpopupfalg = false
        this.$vs.notify({
          title: 'Success',
          text: 'Status Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$vs.loading.close('#delete_status_id > .con-vs-loading')

        // this.editmodalpopupfalg = false
      } catch (e) {
        this.$vs.loading.close('#delete_status_id > .con-vs-loading')
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        
      }
    },
    handlecreateStatus () {
      this.addstatusModal = false
      this.$validator.errors.clear('add_status')
    }
  },
  watch: {
    activeStatus () {
      const rearranged_sattus = this.activeStatus
      rearranged_sattus.map((item, index) => {
        item.status_sequence = `${index + 1}`
      })
      const payload =
      {
        leads_status: rearranged_sattus,
        customer_id: this.$store.getters.customerId
      }
      arrange_leads_status(payload)
        .then(data => {
          console.log(data)
        }).catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
  .list-holder .list-item:not(:last-child),
  .list-holder .active-list:not(:last-child) {
    margin-bottom: 10px;
  }
  .list-holder .vx-card {
    min-height: 80px;
  }
  .list-holder .vs-list--header {
    font-size: 18px;
    padding-left: 10px;
  }
  .list-holder .list-item {
    transition: all 1s;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .list-item .vx-card__header {
    padding: 0 1.5rem 0 0 !important;
  }
  .active-list {
    background: #fff;
    border-radius: .5rem;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    min-height: 80px;
    padding: 0 1.5rem;
  }
  .cstm_list-holder h4 {
    font-size: 14px;
    font-weight: 700;
    color: #626262;
  }
  .status_card_holder > span {
    min-height: 100vh;
    display: block;
  }
</style>
